/**
* Related Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Related Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'related-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      adjustServiceContentPosition();

      $( window ).on( 'resize', function() {
        adjustServiceContentPosition();
      } );

      function adjustServiceContentPosition() {
        if ( window.innerWidth > 1024 ) {
          $( '.related-services-service-content' ).each( function() {
            const learnMoreElement = $( this ).find( '.related-services-learn-more' );
            const learnMoreHeight = learnMoreElement.height();
            $( this ).css( 'transform', `translateY(${learnMoreHeight}px)` );
          } );
        } else {
          $( '.related-services-service-content' ).each( function() {
            $( this ).css( 'transform', 'translateY(0)' );
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'related-services', COMPONENT );
} )( app );
